import { X } from 'lucide-react';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import {
  BannerTheme,
  bannerTheme,
} from '@/code/frontend/components/ui/banner/banner.theme';
import {
  Button,
  ButtonOrLinkProps,
} from '@/code/frontend/components/ui/button/button';
import { cloneElement } from '@/code/lib/utils/cloneElement';
import { cn } from '@/code/lib/utils/cn';

export interface BannerProps
  extends ComponentPropsWithoutRef<'div'>,
    BannerTheme {
  icon?: ReactNode;
  title: string;
  description?: string;
  actions?: ButtonOrLinkProps[];
  onClose?: () => void;
  closeButtonProps?: ButtonOrLinkProps;
}

export const Banner = ({
  icon,
  title,
  description,
  actions,
  onClose,
  closeButtonProps,
  className,
  variant,
  ...props
}: BannerProps) => {
  const {
    base,
    iconWrapper,
    icon: iconStyles,
    content,
    title: titleStyles,
    description: descriptionStyles,
    actionsWrapper,
    closeButton,
  } = bannerTheme({ variant });
  return (
    <div className={cn(base(), className)} {...props}>
      <div className={content()}>
        {icon && (
          <div className={iconWrapper()}>
            {cloneElement({
              element: icon,
              className: iconStyles(),
            })}
          </div>
        )}
        <div className="flex flex-col gap-0.5">
          <p className={titleStyles()}>{title}</p>
          {description && <p className={descriptionStyles()}>{description}</p>}
        </div>
        {actions && (
          <div className={actionsWrapper()}>
            {actions.map((action) => (
              <Button key={`${action.id || action.children}`} {...action} />
            ))}
          </div>
        )}
      </div>
      {onClose && (
        <Button
          variant="ghost"
          size="sm"
          className={closeButton()}
          onClick={onClose}
          iconLeft={<X />}
          aria-label="Close banner"
          {...closeButtonProps}
        />
      )}
    </div>
  );
};
